import React, { useEffect, useState } from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Row, Col, Card } from "antd";
import { PageHeaderLayout } from "../../../shared/layout";
import "./../library/creativestyle.css";
import Button from "../../../shared/globalStyling/Button";
import AdUnitDetailsCard from "./../components/AdUnitDetailsCard";
import AssignedAdGroupsTable from "../components/AssignedAdGroupsTable";
import AdUnitPreviewCard from "../components/AdUnitPreviewCard";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";
import AdUnitAssignmentModal from "../components/AdUnitAssignmentModal";
import { useAssignAdUnits } from "../hooks/assignAdUnits";
import DownloadAdUnitButton from "../components/DownloadAdUnitButton";
import { useDeleteMedias } from "../hooks/useDeleteMedias";

// NEW IMPORTS - Enhanced navigation system
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const AdUnitDetail = () => {
  // NEW: Use centralized navigation hook instead of manual navigation logic
  const { navigateBack } = useCreativeNavigation();

  // Context and state
  const {
    orgMedia,
    adGroupCreatives,
    assignedAdGroupUnit,
    refetchMedias,
  } = useLibraryCreativesContext();

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAdGroupIds, setSelectedAdGroupIds] = useState([]);
  const { handleAssignAdUnits, assigning } = useAssignAdUnits(() =>
    setModalVisible(false)
  );

  const selectedAdUnits = orgMedia ? [orgMedia.media] : [];
  const availableAdGroups = adGroupCreatives || [];
  const { handleDeleteMedias } = useDeleteMedias();

  // NEW: Enhanced back navigation with intelligent fallback
  const handleBackNavigation = () => {
    navigateBack({
      mediaType: 'DISPLAY',
      isAdGroup: false
    });
  };

  const handleDeleteAndRedirect = async ids => {
    try {
      await handleDeleteMedias(ids);
      await refetchMedias();
      handleBackNavigation();
    } catch (error) {
      console.error('Failed to delete media:', error);
      // Error handling is already done in handleDeleteMedias hook
    }
  };

  // Get creative name for breadcrumb
  const creativeName = orgMedia && orgMedia.media ? orgMedia.media.name : "Loading...";
  const creativeId = orgMedia && orgMedia.media ? orgMedia.media.id : null;

  useEffect(() => {
    // Any side effects can be handled here
  }, [orgMedia]);

  return (
    <>

      <PageHeaderLayout
        titleIcon={<AppstoreAddOutlined />}
        title={creativeName}
        centerContent={
          <div>
            <DownloadAdUnitButton
              creativeKeys={
                orgMedia && orgMedia.media ? [orgMedia.media.key] : []
              }
            />
            <Button type="default" onClick={handleBackNavigation}>
              Back
            </Button>
          </div>
        }
      />

      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col xs={24} sm={24} md={24} lg={10}>
          <AdUnitPreviewCard orgMedia={orgMedia} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={14}>
          <AdUnitDetailsCard
            orgMedia={orgMedia}
            assignedAdGroupUnit={assignedAdGroupUnit}
            handleDeleteMedias={handleDeleteAndRedirect}
          />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <Card
            title="ASSIGNED AD GROUPS"
            extra={
              <Button type="default" onClick={() => setModalVisible(true)}>
                Assign to Ad Groups
              </Button>
            }
            style={{ width: "100%" }}
          >
            <AssignedAdGroupsTable assignedAdGroupUnit={assignedAdGroupUnit} />
          </Card>
          <AdUnitAssignmentModal
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            selectedAdUnits={selectedAdUnits}
            availableAdGroups={availableAdGroups}
            selectedAdGroupIds={selectedAdGroupIds}
            setSelectedAdGroupIds={setSelectedAdGroupIds}
            onAssign={() =>
              handleAssignAdUnits(
                selectedAdGroupIds,
                selectedAdUnits.map(u => u.id)
              )
            }
            assigning={assigning}
            mediaType="IMAGE"
          />
        </Col>
      </Row>
    </>
  );
};

export default AdUnitDetail;